import { CategoryWithChildrenResponse, CreateCategoryRequest } from '@bluestone-node-sdk/pim';
import BaseAPIClient from '~/clientUtils/baseApiClient';
import {
    AssignRegionSettingsProps,
    AssignRegionSettingsResponse,
    UpdateRegionSettingsProps,
    UpdateRegionSettingsResponse,
} from '~/definitions/generalSettings';
import { Region } from '~/definitions/region';

class RegionApi extends BaseAPIClient {
    constructor() {
        super('', {});
    }

    async getRegionById(id: string): Promise<Region> {
        return this.request({
            method: 'GET',
            url: `/api/region/${id}`,
        });
    }

    async getRegionList(id: string): Promise<CategoryWithChildrenResponse[]> {
        return this.request({
            method: 'GET',
            url: `/api/region/list/${id}`,
        });
    }

    async deleteRegions(data: string[]): Promise<void> {
        return this.request({
            method: 'POST',
            url: `/api/region/delete`,
            data,
        });
    }

    async createRegion(data: CreateCategoryRequest): Promise<void> {
        return this.request({
            method: 'POST',
            url: `/api/region`,
            data,
        });
    }

    async updateRegion(params: UpdateRegionSettingsProps): Promise<UpdateRegionSettingsResponse> {
        return this.request({
            method: 'PUT',
            url: `/api/region/${params.regionId}`,
            data: { ...params.data },
        });
    }

    async updateRegionSettings(params: UpdateRegionSettingsProps): Promise<UpdateRegionSettingsResponse> {
        return this.request({
            method: 'PUT',
            url: `/api/region/settings/${params.regionId}`,
            data: {
                regionData: params.regionData,
                data: params.data,
            },
        });
    }

    async assignToRegionSettings(params: AssignRegionSettingsProps): Promise<AssignRegionSettingsResponse> {
        return this.request({
            method: 'POST',
            url: `/api/region/settings/${params.regionId}`,
            data: {
                data: params.data,
            },
        });
    }
}

const regionApi = new RegionApi();

export default regionApi;
